import { NavLink } from "react-router-dom";
import React from "react";
import styled from "styled-components/macro";

const ButtonContainer = styled(NavLink)`
  position: relative;

  /* Adapt the colours based on primary prop */
  background: ${(props) =>
    props.primary
      ? props.theme.onSurfaceLight
      : props.danger
      ? props.theme.danger
      : props.theme.onSurfaceLight};

  color: ${(props) => props.theme.onSurfaceLightSecondary};
  cursor: pointer;
  font-size: ${(props) => (props.size === "small" ? ".8rem" : "1rem")};
  width: ${(props) => (props.span ? "100%" : "auto")};
  margin-right: ${(props) => (props.list ? "1rem" : "0")};
  padding: 0.5em 1em;
  display: inline-block;
  border: none;
  transition: all ${(props) => props.theme.transitionSpeed} linear;
  &:hover {
    background: ${(props) =>
      props.primary
        ? props.theme.surfaceAlt
        : props.danger
        ? props.theme.dangerAlt
        : props.theme.surfaceAlt};
  }
  &:disabled {
    pointer-events: "none";
    opacity: 0.3;
    cursor: auto;
    background: ${(props) =>
      props.primary
        ? props.theme.onSurfaceLight
        : props.danger
        ? props.theme.danger
        : props.theme.onSurfaceLight};
  }
`;

const ButtonCenter = styled.div`
  width: 100%;
  text-align: center;
`;

const ButtonInner = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonIcon = styled.div`
  margin-right: ${(props) => (props.iconBump ? ".5rem" : "")};
`;

const Button = (props) => {
  const IconComponent = props?.icon ?? null;

  return props.center ? (
    <ButtonCenter {...props}>
      <ButtonContainer>
        <ButtonInner>
          {IconComponent && (
            <ButtonIcon iconBump={props.iconBump}>
              <IconComponent />
            </ButtonIcon>
          )}
          {props.label}
          {props.children}
        </ButtonInner>
      </ButtonContainer>
    </ButtonCenter>
  ) : (
    <ButtonContainer {...props}>
      <ButtonInner>
        {IconComponent && (
          <ButtonIcon iconBump={props.iconBump}>
            <IconComponent />
          </ButtonIcon>
        )}
        {props.label}
        {props.children}
      </ButtonInner>
    </ButtonContainer>
  );
};

export default Button;
